<template v-if="promoSlideshow">
  <div
    ref="promoSlishowRef"
    :class="['promoSlideshow-container', globalClassAttributes, deviceType]"
    :style="styleAttributes"
  >
    <div
      v-if="!slideshowLoaded && promoSlideshow?.slides?.length &&
        parseInt(promoSlideshow?.attributes?.colCount, 10) >= 2"
      class="extra-margin"
    >
      <PromoSlideshowCard
        v-if="promoSlideshow?.slides[0]"
        :card="promoSlideshow?.slides[0]"
      />
    </div>
    <Slideshow
      v-show="slideshowLoaded"

      v-if="
        promoSlideshow?.slides?.length &&
          parseInt(promoSlideshow?.attributes?.colCount, 10) >= 2
      "
      :autoplay-interval="4000"
      :threshold-limit="0.5"
      :back-to-first="true"
      :list="promoSlideshow?.slides"
      @vue:mounted="resetPlaceholder"
    >
      <template #item="slotProps">
        <PromoSlideshowCard
          v-if="slotProps?.data"
          :card="slotProps?.data"
          :index="slotProps?.index"
        />
      </template>
    </Slideshow>

    <template
      v-if="
        promoSlideshow?.slides?.length &&
          parseInt(promoSlideshow?.attributes?.colCount, 10) === 1
      "
    >
      <template
        v-for="(list, index) in (promoSlideshow?.slides || [])"
        :key="index"
      >
        <PromoSlideshowCard :card="list" />
      </template>
    </template>
  </div>
</template>

<script setup>
import Slideshow from '@atomic-ui/slideshow';
import { ref } from 'vue';
import PromoSlideshowCard from './PromoSlideshowCard';
import {
  getClassAttributes,
  getStyleAttributes,
} from '../../helpers/getAttributes';

const props = defineProps({
  promoSlideshow: {
    type: Object,
    default: () => {},
  },
  meta: {
    type: Object,
    default: () => {},
  },
});

const globalClassAttributes = getClassAttributes(
  props.promoSlideshow?.attributes,
);
const styleAttributes = () => getStyleAttributes(props.promoSlideshow?.attributes);
const deviceType = props.meta?.context?.deviceType?.toLowerCase();

const slideshowLoaded = ref(false);
const promoSlishowRef = ref();

const resetPlaceholder = () => {
  slideshowLoaded.value = true;
  if (promoSlishowRef.value) {
    promoSlishowRef.value.querySelector(' li.slideshow-item map')?.remove();
  }
};

</script>

<style lang="scss" scoped>
.extra-margin{
  margin-bottom:rem-calc(40px);
}
.promoSlideshow-container {
  :deep() {
    .v-dot-indicator-wrapper {
      margin: rem-calc(8px) 0 0 0;
      .button-control {
        outline: none;
      }
    }
  }
}
</style>
<style lang="scss" brand="mcom" scoped>
@import "~@core/csg/src/scss/base.scss";
:deep(){
  @include custom-font-setup('tt-ramillas');
}
@import "./../../scss/globalAttributes.mcom.scss";
</style>

<style lang="scss" brand="bcom" scoped>
@import "~@core/csg/src/scss/base.scss";
:deep(){
  @include custom-font-setup('avant-garde-demi');
  @include custom-font-setup('avant-garde-book');
  @include custom-font-setup('austin');
}
@import "./../../scss/globalAttributes.bcom.scss";
</style>
